import React from "react";

type P_Props = {};

const PolicyPresenter = (props: P_Props) => {
  return (
    <>
      <div>Điều khoản sử dụng và bảo mật</div>
      <div>
        Phiên bản 1.2.21 • Bản quyền thuộc về <span className="bold">Rentus</span>
      </div>
    </>
  );
};

export default PolicyPresenter;
